export default __webpack_public_path__ + "static/media/shippieIcon.d88c9c3c.png";